function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Badge } from 'react-bootstrap';
import { Table } from '@rd-web-markets/shared/dist/util';
import { EditButton, DeleteButton, SaveButton, CancelButton } from '@rd-web-markets/shared/dist/util/buttons';
const CustomerContractsTable = _ref => {
  var _formData$details, _formData$upstream_co, _formData$upstream_re;
  let {
    contracts = [],
    onUpdate,
    onDelete,
    userCanEdit,
    loading
  } = _ref;
  const {
    t
  } = useTranslation();
  const UPSTREAM_CONTRACT_OPTIONS = [{
    value: 'received',
    label: t('received')
  }, {
    value: 'review_in_progress',
    label: t('review_in_progress')
  }, {
    value: 'reviewed',
    label: t('reviewed')
  }];
  const UPSTREAM_REVIEW_OPTIONS = [{
    value: 'nq',
    label: t('nq')
  }, {
    value: 'inconclusive',
    label: t('inconclusive')
  }, {
    value: 'q',
    label: t('q')
  }];
  const [editingContractId, setEditingContractId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({});
  const getUpstreamContractLabel = value => {
    const option = UPSTREAM_CONTRACT_OPTIONS.find(opt => opt.value === value);
    return option ? option.label : value;
  };
  const getUpstreamReviewLabel = value => {
    const option = UPSTREAM_REVIEW_OPTIONS.find(opt => opt.value === value);
    return option ? option.label : value;
  };
  const handleEdit = (index, row) => {
    const contract = row.contract;
    setEditingContractId(contract.id);
    setFormData({
      details: contract.details || '',
      upstream_contract: contract.upstream_contract || '',
      upstream_review: contract.upstream_review || ''
    });
  };
  const handleCancel = () => {
    setEditingContractId(null);
    setFormData({});
  };
  const handleChange = (field, value) => {
    setFormData(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [field]: value
    }));
  };
  const handleSave = async contract => {
    setSaving(true);
    await onUpdate({
      id: contract.id,
      data: formData
    });
    setEditingContractId(null);
    setFormData({});
    setSaving(false);
  };
  const handleDelete = async (index, row) => {
    if (window.confirm(t('confirm_delete'))) {
      await onDelete(row.contract.id);
    }
  };
  const canSave = ((_formData$details = formData.details) === null || _formData$details === void 0 ? void 0 : _formData$details.trim()) !== '' && ((_formData$upstream_co = formData.upstream_contract) === null || _formData$upstream_co === void 0 ? void 0 : _formData$upstream_co.trim()) !== '' && ((_formData$upstream_re = formData.upstream_review) === null || _formData$upstream_re === void 0 ? void 0 : _formData$upstream_re.trim()) !== '';
  const headers = useMemo(() => [{
    text: t('contract_details'),
    width: '30%'
  }, {
    text: t('upstream_contract'),
    width: '20%'
  }, {
    text: t('upstream_review'),
    width: '15%'
  }, {
    text: '',
    width: '10%'
  }], [t]);
  const rows = useMemo(() => {
    return contracts.map(contract => {
      const isEditing = editingContractId === contract.id;
      const isSavingThisRow = saving && isEditing;
      const columns = isEditing ? [/*#__PURE__*/React.createElement(Form.Control, {
        size: "sm",
        name: "details",
        value: formData.details,
        onChange: e => handleChange('details', e.target.value),
        placeholder: t('contract_details')
      }), /*#__PURE__*/React.createElement(Form.Select, {
        size: "sm",
        name: "upstream_contract",
        value: formData.upstream_contract,
        onChange: e => handleChange('upstream_contract', e.target.value)
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, t('select')), UPSTREAM_CONTRACT_OPTIONS.map(option => /*#__PURE__*/React.createElement("option", {
        key: option.value,
        value: option.value
      }, option.label))), /*#__PURE__*/React.createElement(Form.Select, {
        size: "sm",
        name: "upstream_review",
        value: formData.upstream_review,
        onChange: e => handleChange('upstream_review', e.target.value)
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, t('select')), UPSTREAM_REVIEW_OPTIONS.map(option => /*#__PURE__*/React.createElement("option", {
        key: option.value,
        value: option.value
      }, option.label))), /*#__PURE__*/React.createElement("div", {
        className: "d-flex justify-content-end gap-2"
      }, /*#__PURE__*/React.createElement(SaveButton, {
        size: "sm",
        onClick: () => handleSave(contract),
        disabled: isSavingThisRow || !canSave,
        text: isSavingThisRow ? t('saving') : t('save')
      }), /*#__PURE__*/React.createElement(CancelButton, {
        size: "sm",
        onClick: handleCancel,
        disabled: isSavingThisRow
      }))] : [/*#__PURE__*/React.createElement("small", null, contract.details), /*#__PURE__*/React.createElement(Badge, {
        bg: "primary"
      }, t(contract.upstream_contract)), /*#__PURE__*/React.createElement(Badge, {
        bg: "primary"
      }, t(contract.upstream_review)), userCanEdit ? /*#__PURE__*/React.createElement("div", {
        className: "d-flex justify-content-end gap-2"
      }, /*#__PURE__*/React.createElement(EditButton, {
        size: "sm",
        onClick: () => handleEdit(null, {
          contract
        })
      }), /*#__PURE__*/React.createElement(DeleteButton, {
        size: "sm",
        onClick: () => handleDelete(null, {
          contract
        })
      })) : null];
      return {
        key: "".concat(contract.id, "-").concat(isEditing ? 'edit' : 'view'),
        contract: contract,
        columns: columns
      };
    });
  }, [contracts, editingContractId, formData, userCanEdit, saving, t]);
  return /*#__PURE__*/React.createElement("div", {
    className: "customer-contracts-table"
  }, /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows,
    showControls: false,
    opts: {
      bordered: false,
      striped: true,
      responsive: true,
      hover: true,
      headerSticky: true
    },
    style: {
      borderCollapse: 'collapse'
    }
  }));
};
export default CustomerContractsTable;